export default __webpack_public_path__ + "static/media/90s_bg_desktop@3x.6ff1d3b0.jpg";